// components/CodeEditor/index.jsx
import React from "react";
import SecureCodeEditor from "../../../components/SecureCodeEditor";

export const CodeEditor = ({ 
  value, 
  onChange, 
  language = "javascript", 
  height = "300px",
  readOnly = false 
}) => {
  // Converter altura de string para número
  const numericHeight = typeof height === 'string' ? parseInt(height.replace('px', '')) : height;

  return (
    <SecureCodeEditor
      value={value}
      onChange={onChange}
      language={language}
      height={numericHeight}
      readOnly={readOnly}
      showLineNumbers={true}
      placeholder={`Digite seu código ${language} aqui...`}
    />
  );
};

export default CodeEditor;